import PropTypes from 'prop-types'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import RenderRichText from '@components/renderers/render-rich-text'
import defaults from '@config/defaults'
import { NextSeo } from 'next-seo'
import { IconButtonBackArrow } from '@components/atoms/icons/icon-arrow-back'
import ButtonCta from '@components/atoms/button-cta'
import useStyles from './other.styles'

const Other = (props) => {
  const {
    headline,
    eyebrow,
    showBackButton,
    content,
    image,
    metaDescription,
    slug,
    route2,
  } = props
  const styles = useStyles()

  return (
    <div className={styles.other}>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={headline}
        description={metaDescription}
        canonical={`${defaults.baseUrl}${route2.substring(1)}${slug}`}
        openGraph={{
          title: headline,
          type: 'article',
          url: `${defaults.baseUrl}${route2.substring(1)}${slug}`,
          images: [{ url: (image && image.url) }],
        }}
      />
      <Container maxWidth="md">
        <Box pt={5} pb={6} position="relative">
          {showBackButton && (
            <ButtonCta
              startIcon={IconButtonBackArrow()}
              className={styles.backButton}
              href={route2}
            >
              Back
            </ButtonCta>
          )}
          {eyebrow && (
            <Typography color="primary" variant="overline" align="center" gutterBottom>
              {eyebrow}
            </Typography>
          )}
          <Typography variant="h3" component="h1" align="center" gutterBottom>{headline}</Typography>
          {image && <img className={styles.img} src={image.url} alt={image.description} />}
        </Box>
        {content && <RenderRichText {...content} />}
      </Container>
    </div>
  )
}

Other.propTypes = {
  headline: PropTypes.string,
  eyebrow: PropTypes.string,
  showBackButton: PropTypes.bool,
  slug: PropTypes.string,
  route2: PropTypes.string,
  metaDescription: PropTypes.string,
  content: PropTypes.shape({}),
  image: PropTypes.shape({
    url: PropTypes.string,
    description: PropTypes.string,
  }),
}

export default Other
